import { ApiPaymentLogService } from "@/infrastructure/services/ApiPaymentLogService";
import { usePaymentStore } from "@/stores/paymentStore";
import { logger } from "@/infrastructure/services/LoggerService";
export class PaymentLogUseCases {
    constructor(paymentLogService) {
        Object.defineProperty(this, "paymentLogService", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.paymentLogService = paymentLogService || new ApiPaymentLogService();
    }
    /**
     * Log a successful payment event
     */
    async logPaymentSuccess(result, component) {
        await this.logPaymentEvent("success", result, component);
    }
    /**
     * Log a failed payment event
     */
    async logPaymentFailed(result, component) {
        await this.logPaymentEvent("failed", result, component);
    }
    /**
     * Log a payment error event
     */
    async logPaymentError(error, component) {
        await this.logPaymentEvent("error", null, component, error);
    }
    /**
     * Generic method to log payment events
     */
    async logPaymentEvent(status, result, component, error) {
        try {
            // Get session data from the store
            const paymentStore = usePaymentStore();
            // Extract data from various sources
            const sessionId = paymentStore.paymentSession?.sessionId;
            const paymentId = paymentStore.paymentId || undefined;
            const sessionResult = result?.sessionResult;
            // Extract safe component information to avoid circular references
            const safeComponent = component
                ? {
                    id: component._id || component.id,
                    type: component.type || component._component?.type || "unknown",
                    name: component.name || component._component?.name || "unknown",
                }
                : undefined;
            const logData = {
                status,
                result: result || undefined,
                component: safeComponent,
                error: error || undefined,
                createdAt: new Date().toISOString(),
                paymentId: paymentId || undefined,
                sessionId: sessionId || undefined,
                sessionResult: sessionResult || undefined,
            };
            logger.debug("Logging payment event with enhanced data:", {
                status,
                paymentId,
                sessionId,
                sessionResult: sessionResult ? "present" : "not present",
                createdAt: logData.createdAt,
            });
            await this.paymentLogService.logPaymentEvent(logData);
        }
        catch (error) {
            logger.debug("Failed to log payment event:", error);
            // Silent fail - logging shouldn't affect user experience
        }
    }
}
